module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAiCAMAAAAqN3oYAAAAOVBMVEUAAAAgKHEkLHQlLnYkLHYgMHAlLXYkLHYkLHUkLnQlLXUlKnUlLnYjLHUkLXYmLnYlKnAgIHAlLXbrwKVSAAAAEnRSTlMAIEDfgBDvz79wYDCgkK9fMBCxyUUDAAAAhklEQVQ4y+3USQ4CMQwF0XJGkjD6/odFHdR7f5aIty/J9sJslkIWp9E8KE+2qwvKURSXJCC75ALJRVVPjKeLgCbvwnDJkq9c2GYPT5U4VQup/P2cV+k55DKN7dE8LK+jMFc0A7pLbmCuaXzxLvSkUl2T90uWTKBmF3QOdhdOXPlYo4SMHbwBHLpF/G4YfYAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/layout/ui/components/spinner/icons/spinner-equal.png
// module id = 1130
// module chunks = 0